import { useState, useEffect, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Table, TableRow, TableCell, TableBody, Checkbox, Tooltip, Typography } from '@mui/material';
import './MeshListDialog.css';
import MikeButton from '../mike-button';
import { GlobalContext } from '../../store/Store';
import { DialogTitle, DialogFooter } from '../ProviderDialog/ProviderDialog';
import { bgLightGreyStyle, contentScrollbarStyle, meshDialogContentWrapperStyle, tableHeadStyle, tableRowBorderStyle } from './DialogStyles';

export default function MeshListDialog({
  open,
  onClose,
  onSelect,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  onSelect?: (selected) => void;
  onSubmit?: (selected) => void;
}) {
  const [globalState] = useContext(GlobalContext);
  const meshFileList = globalState.meshFilesImported || [];
  
  const projectName: string =
    (globalState.project &&
      globalState.project.currentProject &&
      globalState.project.currentProject.name) ||
    'project';

  const [selected, setSelected] = useState([]);

  const selectMesh = (name: string) => {
    setSelected([...selected, name]);
  };
  const unselectMesh = (name: string) => {
    selected.splice(selected.indexOf(name), 1);
    setSelected([...selected]);
  };
  const onToggleMesh = (name: string) => () => {
    if (selected.indexOf(name) > -1){
      unselectMesh(name)
    } else{
      selectMesh(name);
    } 
  };
  useEffect(() => {
    if (onSelect) onSelect(selected);
  }, [selected]);
  const isSelected = (name: string) => {
    return selected.indexOf(name) > -1;
  };

  // Clear selected when closing the dialog:
  useEffect(() => {
    if(!open){
      setSelected([]);
    } 
  }, [open]);

  const onDeleteClick = () => {
    const wConfirm = window.confirm(
      'This operation will permanently delete the selected mesh file(s) from this project. Are you sure you wish to proceed?'
    );
    if (wConfirm === true) {
      onSubmit([...selected]);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} className="MeshListDialog--root">
      <DialogTitle onClose={onClose}>Delete meshes from {projectName}</DialogTitle>
      <DialogContent sx={meshDialogContentWrapperStyle}>
        <div className={`tableHead ${tableHeadStyle}`}>
          <div className="col1">&nbsp;</div>
          <div className="col2">File name</div>
        </div>
        <div
          className={`MeshListDialog--content ${contentScrollbarStyle} ${bgLightGreyStyle}`}>
          <Table>
            <TableBody>
              {meshFileList &&
                meshFileList.map((meshFile, i) => (
                  <TableRow key={i} className={'tableRow'}>
                    <TableCell padding="checkbox" className={`col1 ${tableRowBorderStyle}`}>
                      <Checkbox
                        checked={isSelected(meshFile.meshName)}
                        onChange={onToggleMesh(meshFile.meshName)}
                      />
                    </TableCell>
                    <TableCell className={`col2 ${tableRowBorderStyle}`}>
                      <div className="tooltipFix">
                        <Tooltip title={meshFile.meshName}>
                          <Typography className="ellip">{meshFile.meshName}</Typography>
                        </Tooltip>
                      </div>
                    </TableCell>
                    {/* Date column commented out temporarely: */}
                    {/* <TableCell className="dateCell" align="right">
                    {toYYYYMMDD(new Date(Math.random() * 59e11))}
                  </TableCell> */}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
      <DialogFooter>
        <MikeButton variant="text" onClick={onClose}>
          Cancel
        </MikeButton>
        <MikeButton onClick={onDeleteClick} disabled={selected.length < 1}>
          Delete
        </MikeButton>
      </DialogFooter>
    </Dialog>
  );
}
